/**
 * Module containing the message manager.
 */
define('commons/message-manager',['jquery', 'jquery.ui'], function() {

    var $container = $('<div id="feedback"></div>');
    var list = [];
    var lock = false;

    /**
     * Build the message manager
     * @constructor
     */
    var Messages = function() {
        $('body').append($container);
    };

    var _show = function() {
        if (lock === false) {
            lock = true;
            var lastMessage = list.pop();
            if (typeof lastMessage != 'undefined') {
                $container.attr('class', lastMessage.type);
                $container.html(lastMessage.message);
                $container.show('slide', {
                    direction: 'up'
                }, 400).delay(5000).hide('slide', {
                    direction: 'up'
                }, 400, function() {
                    lock = false;
                    _show();
                });
            } else {
                lock = false;
            }
        }
    };

    /**
     * @enum {String}
     */
    var Types = {
        INFO: 'info',
        WARN: 'warn',
        ERROR: 'error'
    };

    var _displayMessage = function(message, type) {
        list.unshift({
            message: message,
            type: type
        });
        _show();
    };

    /**
     * Display an error message
     * @param {String} message the message to display
     */
    Messages.prototype.error = function(message) {
        _displayMessage(message, Types.ERROR);
    };

    /**
     * Display an info message
     * @param {String} message the message to display
     */
    Messages.prototype.info = function(message) {
        _displayMessage(message, Types.INFO);
    };

    /**
     * Display a warn message
     * @param {String} message the message to display
     */
    Messages.prototype.warn = function(message) {
        _displayMessage(message, Types.WARN);
    };

    return new Messages();
});

